import { FC } from 'react';

import { useWindowSize } from '../../hook/useWindowSize';
import BusinessButton from '../business-button/business-button';
import { COLORS } from '../business-button/business-button.constants';
import styles from './business-hub-hero-enterprise.module.scss';

export interface BusinessHubHeroEnterPriseProps {
    backgroundColor: string;
    backgroundImage: string;
    backgroundImageMobile: string;

    content?: {
        title: string;
        description: string;
        ctaText: string;
        ctaLink: string;
        image: string;
    };
}

const BusinessHubHeroEnterPrise: FC<BusinessHubHeroEnterPriseProps> = (props) => {
    const { backgroundColor, backgroundImage, backgroundImageMobile, content } = props;

    const windowSize = useWindowSize();
    const windowWidth = windowSize.width || 0;
    const isMobile = windowWidth <= 575;

    return (
        <div
            className={styles.container}
            style={{
                backgroundColor: `${backgroundColor ?? '#ffff'}`,
            }}
        >
            {!isMobile ? (
                <div className={styles.backgroundImage}>
                    <img src={backgroundImage} alt="" />
                </div>
            ) : (
                <div className={styles.backgroundImageMobile}>
                    <img src={backgroundImageMobile} alt="" />
                </div>
            )}

            <div className={styles.wrapperContent}>
                <div className={styles.wrapperContentText}>
                    <div className={styles.title} dangerouslySetInnerHTML={{ __html: content?.title || '' }}></div>
                    <div className={styles.description} dangerouslySetInnerHTML={{ __html: content?.description || '' }}></div>
                    {content?.ctaText && (
                        <div className={styles.button}>
                            <BusinessButton color={COLORS.MINT} link={content.ctaLink} buttonText={content.ctaText}></BusinessButton>
                        </div>
                    )}
                </div>
                <div className={styles.image}>
                    <img src={content?.image} alt="" />
                </div>
            </div>
        </div>
    );
};

export default BusinessHubHeroEnterPrise;
